import './SignIn.scss';

import logo from '../../assets/images/icons/logo.svg';

import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { handleSignIn } from "../../firebase/firebaseAuth";

function SignIn() {
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await handleSignIn(email, password);
            navigate("/moderators");
        } catch (error) {
            console.error("Sign-in error:", error);
        }
    };


    return (
        <main className='sign-in'>
            <section className='sign-in__main'>
                <img src={logo} className='sign-in__main-logo' alt='ZONA logo'></img>
            </section>


            <form onSubmit={handleSubmit} className='sign-in__form'>
                <div className='sign-in__form-group'>
                    <label
                        htmlFor='userEmail'
                        className='sign-in__form-group-label'
                    >
                        E-mail
                    </label>
                    <input
                        id='userEmail'
                        type='email'
                        className='sign-in__form-group-input'
                        value={email}
                        onChange={(event) => setEmail(event.target.value)}
                        placeholder='Enter e-mail'
                    />
                </div>

                <div className='sign-in__form-group'>
                    <label
                        htmlFor='userPassword'
                        className='sign-in__form-group-label'
                    >
                        Password
                    </label>
                    <input
                        id='userPassword'
                        type='password'
                        className='sign-in__form-group-input'
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        placeholder='Enter password'
                    />
                </div>

                <button type='submit' className='sign-in__form-button'>
                    <p className='sign-in__form-button-text'>
                        Continue
                    </p>
                </button>
            </form>

        </main>
    )
}

export default SignIn;